module.exports = __webpack_public_path__ + "static/media/spider.749ea132.svg";